import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    rootTabs: {
      width: '100%',
      borderBottom: `1px solid ${palette.lightGray}`,
    },
    loadingContainer: {
      marginTop: 26,
    },
    tabs: {
      minHeight: 40,

      '& .MuiTabs-indicator': {
        background: palette.darkGray,
      },
    },
    tab: {
      fontSize: 12,
      fontWeight: 500,
      color: palette.darkGray,
      minHeight: 40,

      '&:hover': {
        textDecoration: 'none',
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
      },
    },

    table: {
      '& .MuiTableHead-root': {
        background: 'transparent',
      },
      '& .MuiTableRow-root': {
        height: 40,
      },
      '& .MuiTableCell-root': {
        fontSize: 12,
        color: palette.darkGray,
        fontWeight: typography.fontWeightMedium,
      },
      '& .MuiTableCell-head': {
        fontWeight: typography.fontWeightRegular,
      },
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    tabYellow: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navCompanyContextActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabGreen: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navAdminActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabGray: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navSuperAdminActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabBlue: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navOperatorActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabsYellow: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navCompanyContextActions,
      },
    },
    tabsGreen: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navAdminActions,
      },
    },
    tabsGray: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navSuperAdminActions,
      },
    },
    tabsBlue: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navOperatorActions,
      },
    },
  });
